import React from 'react';
import {
  MdPayments, MdCalendarMonth, MdAccountBalanceWallet, MdCheckCircle, MdWarningAmber,
} from 'react-icons/md';
import { Card, StatCard, Badge, EmptyState } from '../../ui/Card';
import { money, monthLabel } from '../../ui/format';
import { useStudentData } from '../StudentDataContext';
import './pages.css';

export default function Fees() {
  const { fees, profile } = useStudentData();

  if (!fees) {
    return (
      <div className="page">
        <h1 className="page-title">الأقساط</h1>
        <Card><EmptyState icon={MdPayments} title="لا توجد بيانات أقساط" /></Card>
      </div>
    );
  }

  const exempt = fees.status === 'أعفاء من القسط';
  // No monthly fee set at all is its own state: "paid" would be a lie
  // and "unpaid" would be worse, so it gets its own neutral wording.
  const noFee = fees.monthly_due_cents === 0 && !exempt;
  const paid = fees.current_month_paid;

  return (
    <div className="page">
      <h1 className="page-title">الأقساط</h1>

      {/* The single question a parent opens this page to answer. */}
      <div className={`fees-banner ${exempt || noFee ? 'is-exempt' : paid ? 'is-paid' : 'is-due'}`}>
        <div className="fees-banner-icon">
          {paid || exempt || noFee ? <MdCheckCircle /> : <MdWarningAmber />}
        </div>
        <div>
          <strong>
            {exempt ? 'معفى من القسط'
              : noFee ? 'لا يوجد قسط مستحق'
              : paid ? `قسط ${monthLabel(fees.current_month)} مسدد`
              : `قسط ${monthLabel(fees.current_month)} غير مسدد`}
          </strong>
          <span>
            {noFee ? 'لم يُحدَّد قسط شهري لهذا الطالب'
              : fees.paid_through_month ? `مدفوع حتى ${monthLabel(fees.paid_through_month)}`
              : 'لم تُسجَّل أي دفعة بعد'}
          </span>
        </div>
      </div>

      <div className="stat-grid">
        <StatCard
          icon={MdCalendarMonth}
          tone="primary"
          value={money(fees.monthly_due_cents)}
          label="القسط الشهري"
        />
        <StatCard
          icon={MdAccountBalanceWallet}
          tone="success"
          value={money(fees.total_paid_cents)}
          label="إجمالي المدفوع"
        />
        <StatCard
          icon={MdPayments}
          tone={fees.remaining_cents > 0 ? 'warning' : 'info'}
          value={money(fees.remaining_cents)}
          label="المتبقي"
        />
        {fees.credit_cents > 0 && (
          <StatCard
            icon={MdAccountBalanceWallet}
            tone="info"
            value={money(fees.credit_cents)}
            label="رصيد جزئي"
            hint="يُحتسب من القسط القادم"
          />
        )}
      </div>

      <Card title="تفاصيل القسط" icon={MdPayments} padded={false}>
        <ul className="row-list">
          <li className="row">
            <div className="row-main"><div className="row-title">القسط الدراسي الشهري</div></div>
            <span className="row-score">{money(profile?.tuition_fee || 0)}</span>
          </li>
          <li className="row">
            <div className="row-main">
              <div className="row-title">قسط النقل الشهري</div>
              {!profile?.transportation_id && <p className="row-sub">لا يستخدم مواصلات المدرسة</p>}
            </div>
            <span className="row-score">{money(profile?.transport_fee || 0)}</span>
          </li>
          <li className="row">
            <div className="row-main"><div className="row-title">الحالة</div></div>
            <Badge tone={exempt ? 'info' : paid ? 'success' : 'danger'}>{fees.status}</Badge>
          </li>
        </ul>
      </Card>

      <p className="page-note">
        للاستفسار عن الأقساط أو تسجيل دفعة، يرجى مراجعة مكتب المدرسة.
      </p>
    </div>
  );
}
